import request from '@/utils/request';

// 分页获取资产规划
export function getAssetPlanPage(params) {
	return new Promise((resolve, reject) => {
		request({
			url: '/api/asset/plan/page',
			method: 'get',
			params,
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '获取资产规划失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

// 资产规划统计
export function getAssetPlanStatistics(params) {
	return new Promise((resolve, reject) => {
		request({
			url: '/api/asset/plan/statistics',
			method: 'get',
			params,
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '资产规划统计失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

// 新增资产规划
export function getAssetPlanSave(data) {
	return new Promise((resolve, reject) => {
		request({
			url: '/api/asset/plan/save',
			method: 'post',
			data,
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '新增资产规划失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

// 更新资产规划
export function getAssetPlanUpdate(data) {
	return new Promise((resolve, reject) => {
		request({
			url: '/api/asset/plan/update',
			method: 'put',
			data,
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '更新资产规划失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

// 新增资产规划进度
export function getAssetPlanProgressSave(data) {
	return new Promise((resolve, reject) => {
		request({
			url: '/api/asset/plan/progress/save',
			method: 'post',
			data,
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '新增资产规划进度失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

// 根据ID获取资产规划
export function getAssetPlanById(id) {
	return new Promise((resolve, reject) => {
		request({
			url: `/api/asset/plan/get/${id}`,
			method: 'get',
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '根据ID获取资产规划失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

// 导出资产规划列表
export function exportAssetPlanList(params) {
	return new Promise((resolve, reject) => {
		request({
			url: `/api/asset/plan/export`,
			method: 'get',
			params,
			responseType: 'blob',
		})
			.then(response => {
				resolve(response);
			})
			.catch(error => {
				reject(error);
			});
	});
}
